export const LogoutConfirmationModalStyles = {
    overlay: "fixed inset-0 z-[9999] bg-black bg-opacity-50 flex justify-center items-start pt-[8vh]",
    modalContainer: "bg-white rounded-2xl shadow-2xl mx-4 max-w-[540px] w-full flex-shrink-0",
    container: "flex flex-col items-center sm:pt-6 sm:pb-6 sm:px-8 pt-4 pb-4 px-4 sm:gap-3 gap-2",
    iconWrapper: "flex items-center justify-center",
    icon: "w-10 h-10 sm:w-12 sm:h-12",
    titleWrapper: "text-center",
    title: "text-[18px] sm:text-[20px] font-semibold text-center text-black font-montserrat",
    messageWrapper: "text-center px-3 sm:px-6",
    message: "font-montserrat font-light text-[14px] sm:text-[16px] text-center",
    buttonsContainer: "flex flex-col sm:flex-row w-full sm:gap-3 gap-3 mt-3",
    logoutButton: "font-montserrat font-semibold leading-[24px] text-white py-3",
    stayButton: "w-full border border-[#951F6F] rounded-[8px] py-2 text-[#951F6F] font-montserrat font-semibold text-[16px] leading-[24px]"
};